import { StyleFn } from '..'

export const Badge: StyleFn = ({ color, font, size }) => ({
  root: {
    display: 'inline-block',
    position: 'relative',
    // increased specificity for color variants
    '&$_info > $count': {
      color: color.background.interactive.info.contrastText,
      backgroundColor: color.background.interactive.info.default,
    },
    '&$_success > $count': {
      color: color.background.interactive.success.contrastText,
      backgroundColor: color.background.interactive.success.default,
    },
    '&$_warning > $count': {
      color: color.background.interactive.warning.contrastText,
      backgroundColor: color.background.interactive.warning.default,
    },
    '&$_error > $count': {
      color: color.background.interactive.error.contrastText,
      backgroundColor: color.background.interactive.error.default,
    },
  },
  count: {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(50%, -50%)',
    transformOrigin: '100% 0%',
    boxSizing: 'border-box',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
    minWidth: size.spacing[16],
    height: size.spacing[16],
    lineHeight: size.spacing[16],
    borderRadius: size.spacing[8],
    padding: `0 ${size.spacing[4]}`,
    color: color.palette.white,
    backgroundColor: color.palette.coolgrey[60],
    fontSize: font.size.xsmall,
    fontWeight: font.weight.bold,
  },
  _info: {},
  _success: {},
  _warning: {},
  _error: {},
})
